<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h2>Histórico de acessos de {{ username }}</h2>

          <p class="mt-4">🕑 <strong>Total tempo ativo:</strong> {{ totalActiveTime }}</p>

          <b-table striped hover
            class="mt-4"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            responsive="md"
            primary-key="id"
          >
          </b-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'AdminUsersLoginHistory',
  props: [
    'username'
  ],
  data () {
    return {
      fields: [
        {key: 'user_agent', label: '💻 Dispositivo', formatter: this.$options.filters.userAgent},
        {key: 'active_time', label: '🕑 Tempo ativo', formatter: this.$options.filters.secToHms, headerTitle: 'Formato: hh:mm:ss'},
        {key: 'from', label: '🗺 Local'},
        {key: 'at', label: '🗓 Data', formatter: this.$options.filters.date}
      ],
      items: [],
      sortBy: 'at',
      sortDesc: true,
      userId: parseInt(this.$route.params.id),
      totalActiveTime: 0
    }
  },
  async created () {
    await this.getLogs(this.userId)
  },
  methods: {
    async getLogs (userId) {
      try {
        const resp = await this.$http.get(process.env.VUE_APP_URL_APP + `/b/admin/users/${userId}/logs`)
        this.items = resp.body.logs
        this.totalActiveTime = this.$options.filters.secToHms(resp.body.total_active_time)
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>
